import { useState, useEffect, useRef, useMemo } from "react";

interface UseCharFitOptions {
    widthPxChar?: number;
    defaultChars?: number;
}

export const useCharFit = (options: UseCharFitOptions = {}) => {
    const { widthPxChar = 8, defaultChars = 20 } = options;
    const [cellWidth, setCellWidth] = useState(0);
    const cellRef = useRef<HTMLDivElement | null>(null);

    const charsThatCanFit = useMemo(
        () => (cellWidth ? Math.floor(cellWidth / widthPxChar) : defaultChars),
        [cellWidth, widthPxChar, defaultChars],
    );

    useEffect(() => {
        const updateWidth = () => {
            if (cellRef.current) {
                setCellWidth(cellRef.current.offsetWidth);
            }
        };

        updateWidth();
        window.addEventListener("resize", updateWidth);

        return () => window.removeEventListener("resize", updateWidth);
    }, []);

    return { cellRef, charsThatCanFit };
};
